import { render, staticRenderFns } from "./EntrustRecord.vue?vue&type=template&id=c2fea6ae&"
import script from "./EntrustRecord.vue?vue&type=script&lang=js&"
export * from "./EntrustRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports